import { useState } from 'react';

export interface UsePasswordVisibility {
  type: 'password' | 'text';
  visible: boolean;
  toggle: () => void;
  iconName: 'eye' | 'eye slash';
}

export function usePasswordVisibility(): UsePasswordVisibility {
  const [visible, setVisible] = useState(false);
  return {
    type: visible ? 'text' : 'password',
    visible,
    toggle: () => setVisible(v => !v),
    iconName: visible ? 'eye slash' : 'eye',
  };
}
